import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios";
import {
  API_BASE_URL,
  PAYMENT_GATEWAY,
  CURRENCY,
  RAZORPAY_KEY_ID,
  PAYMOB_IFRAME_ID,
} from "../config/constants";

const ConfigContext = createContext({
  paymentGateway: "razorpay",
  currency: "INR",
  razorpayKeyId: null,
  paymobIframeId: null,
  paymobUseFlash: false,
  paymobPublicKey: null,
  paymobUnifiedCheckoutBase: null,
  loading: true,
  error: null,
});

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({
    paymentGateway: PAYMENT_GATEWAY,
    currency: CURRENCY,
    razorpayKeyId: RAZORPAY_KEY_ID || null,
    paymobIframeId: PAYMOB_IFRAME_ID || null,
    paymobUseFlash: false,
    paymobPublicKey: null,
    paymobUnifiedCheckoutBase: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchConfig = async () => {
      try {
        const resp = await axios.get(`${API_BASE_URL}/api/config`, { timeout: 5000 });
        if (mounted && resp.data) {
          setConfig({
            paymentGateway: resp.data.paymentGateway || "razorpay",
            currency: resp.data.currency || "INR",
            razorpayKeyId: resp.data.razorpayKeyId || null,
            paymobIframeId: resp.data.paymobIframeId || null,
            paymobUseFlash: !!resp.data.paymobUseFlash,
            paymobPublicKey: resp.data.paymobPublicKey || null,
            paymobUnifiedCheckoutBase: resp.data.paymobUnifiedCheckoutBase || null,
          });
        }
      } catch (e) {
        if (mounted) {
          setError(e.message);
          // Keep defaults from env
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetchConfig();
    return () => { mounted = false; };
  }, []);

  const value = useMemo(
    () => ({ ...config, loading, error }),
    [config, loading, error]
  );

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
